import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { findIndex as _findIndex } from 'lodash';

import { getNameInCurrentLanguage } from 'helpers/intl';

import DataId from 'components/DataId';

import FormInput from 'components/forms/FormInput';
import FormTags from 'components/forms/FormTags';

class FormDynamicData extends React.Component {
  // check if the dynamic data definitions are loading
  isDynDataPending = () => {
    const { dynData, metaIdentifier } = this.props;

    return dynData[metaIdentifier] !== undefined ? dynData[metaIdentifier].pending : true;
  };

  // get dynamic data definitions
  getDynData = () => {
    const { dynData, metaIdentifier } = this.props;

    if (this.isDynDataPending()) {
      return { list: [] };
    }

    const list = dynData[metaIdentifier].data.list.filter(definition => !!definition.id);
    const count = list.length;

    return {
      ...dynData[metaIdentifier].data,
      list,
      count,
    };
  };

  getDynParamValue = definition => {
    const { entity } = this.props;
    const entityDynData = entity.getDynData();

    const dynDataParamIndex = _findIndex(entityDynData, ['id', definition.id]);

    if (dynDataParamIndex >= 0) {
      return definition.is_multiple ? entityDynData[dynDataParamIndex].values : entityDynData[dynDataParamIndex].value;
    }

    return definition.is_multiple ? [] : '';
  };

  updateDynParamValue = (definition, value) => {
    const { entity, changeEntity } = this.props;
    const entityDynData = entity.getDynData();

    const dynDataParamIndex = _findIndex(entityDynData, ['id', definition.id]);

    if (dynDataParamIndex >= 0) {
      // if the parameter already exists, we need to update it now
      const newParam = {
        ...entityDynData[dynDataParamIndex],
        value: definition.is_multiple ? '' : value,
        values: definition.is_multiple ? value : null,
      };

      const newEntity = { ...entity.updateValue(dynDataParamIndex.toString(), newParam, ['dynData']) };
      changeEntity(newEntity);
    } else {
      // if the parameter does not exist, we need to add it now
      const newParam = entity.createValue('dynData', [], {
        id: definition.id,
        definition_id: definition.definition_id,
        definition,
        value: definition.is_multiple ? '' : value,
        values: definition.is_multiple ? value : null,
      });

      const newDynData = entityDynData.slice();
      newDynData.push(newParam);

      const newEntity = { ...entity.updateValue('dynData', newDynData) };
      changeEntity(newEntity);
    }
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      metaIdentifier,
    } = this.props;

    const dynData = this.getDynData();

    return (
      <div>
        <DataId
          dataIdName="dynData"
          dataIdId={metaIdentifier}
          url={'/api/dynamicdatadefinitions.json?filters[metaIdentifier]=' + metaIdentifier}
        />

        {dynData.list.length ? (
          <div class="panel panel-transparent">
            <div class="panel-body">
              <p className="form-group-title">{'More information'}</p>
              <div class="form-group-attached">
                {dynData.list.map(definition => {
                  if (definition.is_multiple) {
                    return (
                      <FormTags
                        name={definition.id}
                        key={definition.id}
                        label={getNameInCurrentLanguage(definition.name, appIntl)}
                        value={this.getDynParamValue(definition)}
                        onChange={(name, value) => this.updateDynParamValue(definition, value)}
                        messages={messages}
                      />
                    );
                  }

                  return (
                    <FormInput
                      name={definition.id}
                      key={definition.id}
                      label={getNameInCurrentLanguage(definition.name, appIntl)}
                      value={this.getDynParamValue(definition)}
                      onChange={(name, value) => this.updateDynParamValue(definition, value)}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    dynData: state.dataId.dynData,
  };
};

export default injectIntl(connect(mapStateToProps)(FormDynamicData));
